<template>
  <div class="floor-news floor">
    <div class="container">
      <h2 class="floor__h2">媒体报道</h2>
      <hr class="floor__line">
      <p class="floor__desc">为用户创造价值，为环保公益助力</p>
      <div class="clear-box clearfix">
        <div class="news-list fl clearfix">
          <a class="news-item" v-for="(item, index) in list" :key="index" :href="item.link" target="_blank">
            <img class="news-item__media fl" v-lazy="item.media">
            <div class="news-item__right fl">
              <h3 class="news-item__title" v-text="item.title"></h3>
              <p class="news-item__summary" v-text="item.summary"></p>
            </div>
          </a>
        </div>
        <div class="card-article fr">
          <i class="icon-arrow-right" @click="next"></i>
          <p class="card-article__title">热门文章</p>
          <div class="card-article__list swiper-container" v-swiper:mySwiper="swiperOption">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in currentList" :key="index">
                <a
                  class="article-item"
                  :class="'article-item-'+(cIndex+1+index*per)"
                  v-for="(cItem, cIndex) in item"
                  :key="cIndex"
                  :href="'https://www.huishoubao.com/news/'+cItem.fid+'.html'"
                  target="_blank"
                >
                  <span class="article-item__sort" v-text="cIndex+1+index*per"></span>
                  <span class="article-item__title" v-text="cItem.ftitle"></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Vue from 'vue';

if (process.env.VUE_ENV !== 'server') {
  require('swiper/dist/css/swiper.css');
  const VueAwesomeSwiper = require('vue-awesome-swiper/dist/ssr');
  Vue.use(VueAwesomeSwiper);
}

const list = [
  {
    title: '回收宝携手荣耀、闲鱼，探索电商直播新玩法',
    summary: '1月7日晚，回收宝联合荣耀手机进行以旧换新专场直播，现场不仅有小姐姐和估价工程师在线答疑，而且通过参与直播活动还能领取最高2800元的购机补贴红包。此次直播还联合闲鱼入驻玩家直播，为更多荣耀粉丝带来了福利。',
    media: '//s1.huishoubao.com/static/hsb_hw_bg.jpg',
    link: 'https://www.sohu.com/a/365501266_120279228'
  },
  {
    title: '回收宝618战报：线上回收交易额再迎新高',
    summary: '战报数据显示，2020年6月1日-6月18日，回收宝线上回收交易额同比增长446.69%，线下小站交易额同比增长346.44%，可乐优品交易额同比增长232.57%。',
    media: '//s1.huishoubao.com/static/hsb_2020618_bg.jpg',
    link: 'https://news.mydrivers.com/1/696/696374.htm'
  }
];

export default {
  data () {
    return {
      list: list,
      swiperOption: {
        observeParents: true,
        observer: true
      }
    };
  },
  computed: {
    ...mapState({
      per: () => 7,
      articleList: state => state.hsbArticle.articleList,
      currentList () {
        const list = [];
        let num = this.articleList.length / this.per;
        for (let index = 0; index < num; index++) {
          list.push(this.articleList.slice(index * this.per, this.per * (index + 1)));
        }
        return list;
      }
    })
  },
  methods: {
    next () {
      const instance = this.mySwiper;
      if (instance.activeIndex === this.currentList.length - 1) {
        instance.slideTo(0);
      } else {
        instance.slideNext();
      }
    }
  }
};
</script>

<style lang="postcss" scoped>

@import 'config.css';

.floor-news {
  background-color: #F3F4F7;
  overflow: hidden;
}

.news-item {
  overflow: hidden;
  display: block;
  width: 892px;
  height: 160px;
  margin-bottom: 10px;
  background-color: #fff;
  color: inherit;
  &__right {
    overflow: hidden;
    width: 607px;
    padding-left: 24px;
    padding-right: 24px;
  }
  &__summary {
    max-height: 55px;
    margin-top: 20px;
    line-height: 1.8;
    color: #9f9f9f;
    text-align: justify;
  }
  &__title {
    overflow: initial;
    margin-top: 34px;
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 500;
    &:hover {
      color: $active-a-color;
    }
  }
}

.card-article {
  position: relative;
  width: 297px;
  /* height: 500px; */
  height: 330px;
  padding-left: 20px;
  padding-right: 20px;
  background-color: #fff;
  &__title {
    margin-top: 22px;
    font-size: 16px;
  }
  &__list {
    height: 400px;
    margin-top: 22px;
    color: #9f9f9f;
  }
}

.article-item {
  display: block;
  height: 20px;
  line-height: 20px;
  margin-bottom: 20px;
  color: #9f9f9f;
  &:hover {
    color: $active-a-color;
  }
  &__sort {
    display: inline-block;
    width: 20px;
    height: 20px;
    line-height: 20px;
    margin-right: 10px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    border-radius: 50%;
    background-color: #9f9f9f;
  }
}

.icon-arrow-right {
  position: absolute;
  top: 20px;
  right: 10px;
  display: block;
  width: 20px;
  height: 20px;
  background-image: url(https://www.huishoubao.com/static/pc/1001/img/7_02.png);
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
}

.article-item-1 .article-item__sort,
.article-item-2 .article-item__sort,
.article-item-3 .article-item__sort {
  background-color: #000;
}

.article-item__title {
  display: inline-block;
  width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/welcome/floor-news.vue